<template>
  <!-- 统一配置默认参数，支持通过 props 覆盖 -->
  <el-popover :placement="placement" :trigger="trigger" :width="width" v-bind="$attrs">
    <!-- 内容区：优先渲染传入的 links 数组，否则渲染 content 文本，最后支持自定义插槽 -->
    <div v-if="links && links.length" class="linkWrap">
      <p v-if="title" class="fs12 grey">{{ title }}</p>
      <p v-for="(link, index) in links" :key="index" :class="{ pt2: index === 0 }">
        <a :href="getHref(link)" target="_blank" class="lh14">
          {{ getLinkLabel(link) }}
        </a>
      </p>
    </div>

    <div v-else-if="content">
      <p class="fs12">{{ content }}</p>
    </div>

    <!-- 如果以上都不满足，支持自定义复杂的 HTML -->
    <slot v-else></slot>

    <!-- 触发点：默认是一个问号图标，支持自定义 class -->
    <span slot="reference" :class="[icon, iconClass || 'fs16 lucency ml14 otn']"></span>
  </el-popover>
</template>

<script>
export default {
  name: "InfoPopover",
  props: {
    placement: { type: String, default: "top" },
    trigger: { type: String, default: "hover" },
    width: { type: [String, Number], default: "auto" },
    title: { type: String, default: "" }, // 链接上方的标题
    content: { type: String, default: "" }, // 纯文本内容
    links: { type: Array, default: () => [] }, // 链接数组 [{zh: '', en: '', label: ''}]
    iconClass: { type: String, default: "" }, // 自定义图标样式
    icon: { type: String, default: "el-icon-question" }, // 图标
  },
  computed: {
    getLanguage() {
      return this.$i18n.locale || "zh"; // 根据你的实际 i18n 获取方式修改
    },
  },
  methods: {
    getHref(link) {
      return this.getLanguage === "zh" ? link.zh : link.en || link.zh;
    },
    getLinkLabel(link) {
      // 如果有 label 则显示 label（支持 i18n），否则直接显示链接地址
      return link.label || this.getHref(link);
    },
  },
};
</script>
